/* global localStorage */

import * as MutationTypes from './mutation-types'
import { mapGetters, mapState, mapSetters } from 'vuex'

const getDefaultState = () => {
  return {
          isCompany: false,
          deductVat: false,
          title: '',
          companyName: '',
          firstName: '',
          lastName: '',
          street: '',
          number: '',
          zip: '',
          city: '',
          email: '',
          phone: '',
          optionsInvoiceAddress: false,
      
  }
}

const state = getDefaultState()

const getters = {
  getCustomerAddress (state) {
    return state;
  }
}

const actions = {
  resetCustomerAddress ({ commit }) {
    commit('resetState')
  },
}

const mutations = {
  setCustomerAddress (state, item){
      state = item;
  },
  resetState (state) {
    // Merge rather than replace so we don't lose observers
    // https://github.com/vuejs/vuex/issues/1118
    Object.assign(state, getDefaultState())
}
}

export default {
  state,
  mutations,
  getters,
  actions
}
